import styled from 'styled-components'
import { desktopBreakpoint, tabletBreakpoint, wideScreenBreakpoint } from 'react-components'

export const BreadcrumbSkeletonContainer = styled.div<{ containerPadding?: string }>`
    position: relative;
    max-width: 83rem;
    width: 100%;
    left: 50%;
    transform: translate(-50%);
    padding: ${({ containerPadding }) => containerPadding ?? '1.5rem 1rem 0'};
    line-height: 1rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;

    /* Hide first 4 children (2 breadcrumbs + 2 separators) on mobile */
    & > *:nth-child(-n + 4) {
        display: none;
    }

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: ${({ containerPadding, theme }) => containerPadding ?? `1rem ${theme.spacing.large} 0`};

        /* Show all children on tablet and above */
        & > *:nth-child(-n + 4) {
            display: block;
        }
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: ${({ containerPadding }) => containerPadding ?? '1.25rem 1.5rem 0'};
    }

    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        padding: ${({ containerPadding }) => containerPadding ?? '1.25rem 4rem 0'};
    }
`

export const SkeletonItem = styled.div`
    height: 0.875rem;
    border-radius: 0.25rem;
    background: #f6f7f8;
`

export const SkeletonBreadcrumb = styled(SkeletonItem)<{ $width?: string }>`
    width: ${({ $width }) => $width ?? '4rem'};
`

export const SkeletonSeparator = styled(SkeletonItem)`
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
`
